export default __webpack_public_path__ + "static/media/21.65bb1bcc.png";